"use client";

import { Message } from "@/lib/core/crm/types";
import { MessageActionHandlers } from "./hooks/useMessageActionHandlers";
import { ActionButton, ACTION_CONFIGS, type ActionButtonConfig } from "./ActionButton";

interface MessageMobileActionsProps {
  message: Message;
  handlers: MessageActionHandlers;
  onCopyLink?: () => void;
  className?: string;
}

// Fully static configs (no props/state referenced) → hoisted to module scope so
// the reference is stable across renders (MEMO_STABLE_PROPS).
const REPLY_ACTION_CONFIG: ActionButtonConfig = {
  ...ACTION_CONFIGS.reply,
  showLabel: true,
};

const FORWARD_ACTION_CONFIG: ActionButtonConfig = {
  ...ACTION_CONFIGS.forward,
  showLabel: true,
};

const CREATE_TASK_ACTION_CONFIG: ActionButtonConfig = {
  ...ACTION_CONFIGS.createTask,
  showLabel: true,
};

export function MessageMobileActions({
  message,
  handlers,
  onCopyLink,
  className,
}: MessageMobileActionsProps) {
  return (
    <div className={`sm:hidden ${className || ""}`}>
      {/* Primary Actions - Reply/Forward/Create Task */}
      <div className="flex items-center space-x-2">
        <ActionButton config={REPLY_ACTION_CONFIG} handlers={handlers} className="flex-1 h-12" />

        <ActionButton config={FORWARD_ACTION_CONFIG} handlers={handlers} className="flex-1 h-12" />

        <ActionButton
          config={CREATE_TASK_ACTION_CONFIG}
          handlers={handlers}
          className="flex-1 h-12"
        />
      </div>
    </div>
  );
}
